module.exports = __webpack_public_path__ + "static/media/ideation-experience-map.b8beef67.png";